
import { reactive } from '@nuxtjs/composition-api'
import useTracking from '~/composable/tracking/useTracking'

export default {
  name: 'TlmCheckoutSecretNumber',
  props: {
    defaultValue: {
      type: Object,
      default: () => {}
    }
  },
  setup (props, { emit }) {
    const { trackFieldRule } = useTracking()

    const context = reactive({
      selected: false,
      radioGroup: 'SecretNone'
    })

    const onChange = () => {
      emit('input', { ...context })
    }
    const init = () => {
      context.selected = props.defaultValue.selected
      context.radioGroup = props.defaultValue.radioGroup
    }

    init()
    return {
      secretNumberRules: [
        v => !!v || trackFieldRule({ message: 'Du skal vælge om du ønsker hemmeligt nummer eller adresse eller begge dele', fieldName: 'secret number' })
      ],
      context,
      onChange
    }
  }
}
